import { createReducer } from '@reduxjs/toolkit';

import { SignResultStateType } from '../../types';
import { setOperationResult } from '../actions/sign-result';

const initialState: SignResultStateType = {
  releaseCfa: {},
  buyingCfa: {},
  credit: {},
  saleCfa: {},
  orderUcp: {},
};

const signResultReducer = createReducer(initialState, (builder) => {
  builder.addCase(setOperationResult, (state, action) => {
    state[action.payload.name].success = action.payload.status;
    if (action.payload.msg) {
      state[action.payload.name].msg = action.payload.msg;
    }
  });
});

export default signResultReducer;
